export const apiAddress = 'https://planning.gate15.be';
// export const apiAddress = 'https://gate15planning-staging.rombit.be';
// export const apiAddress = 'http://localhost:8000';
